import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RegisterBlock from "../features/User/RegisterBlock";

const AppRegister: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<RegisterBlock />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRegister;
